__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "school-manager";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@plurall/client", "5.0.19", () => (Promise.all([__webpack_require__.e(724), __webpack_require__.e(287), __webpack_require__.e(852), __webpack_require__.e(991), __webpack_require__.e(490)]).then(() => (() => (__webpack_require__(51852))))));
			register("@plurall/elo-beta", "2.0.0-beta.523", () => (Promise.all([__webpack_require__.e(984), __webpack_require__.e(470), __webpack_require__.e(283), __webpack_require__.e(205), __webpack_require__.e(805), __webpack_require__.e(227)]).then(() => (() => (__webpack_require__(69590))))));
			register("@plurall/widget-teacher-classes", "1.0.36", () => (Promise.all([__webpack_require__.e(287), __webpack_require__.e(684), __webpack_require__.e(283), __webpack_require__.e(205)]).then(() => (() => (__webpack_require__(36684))))));
			register("@sentry/react", "7.120.4", () => (Promise.all([__webpack_require__.e(724), __webpack_require__.e(721), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(77721))))));
			register("ag-grid-community", "29.3.5", () => (__webpack_require__.e(436).then(() => (() => (__webpack_require__(64436))))));
			register("ag-grid-react", "29.3.5", () => (Promise.all([__webpack_require__.e(973), __webpack_require__.e(283), __webpack_require__.e(205), __webpack_require__.e(805), __webpack_require__.e(276)]).then(() => (() => (__webpack_require__(89973))))));
			register("client-oauth2", "4.3.3", () => (__webpack_require__.e(710).then(() => (() => (__webpack_require__(26710))))));
			register("graphql-tag", "2.12.6", () => (Promise.all([__webpack_require__.e(135), __webpack_require__.e(991)]).then(() => (() => (__webpack_require__(2135))))));
			register("graphql", "16.14.1", () => (__webpack_require__.e(547).then(() => (() => (__webpack_require__(91547))))));
			register("lodash.debounce", "4.0.8", () => (__webpack_require__.e(181).then(() => (() => (__webpack_require__(20181))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(283), __webpack_require__.e(205)]).then(() => (() => (__webpack_require__(92648))))));
			register("react-router-prop-types", "1.0.5", () => (Promise.all([__webpack_require__.e(805), __webpack_require__.e(760)]).then(() => (() => (__webpack_require__(91760))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("xlsx", "0.18.5", () => (Promise.all([__webpack_require__.e(959), __webpack_require__.e(686)]).then(() => (() => (__webpack_require__(3959))))));
			initExternal(55894);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};